
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 365","d":"M64 32A32 32 0 104.44 48.26L.12 63.87l15.61-4.32A32 32 0 0064 32zm-36.91-7.46h-4.91a9.82 9.82 0 1116.45 7.25l-4.17 3.82v3.83h-4.92v-6l5.77-5.27a4.84 4.84 0 001.6-3.63 4.91 4.91 0 10-9.82 0zm2.46 19.81h4.91v4.91h-4.92z"}})])
          )
        }
      }
    